 
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import Grid from '@mui/material/Grid';
import dealAPI from 'services/apis/deal';
import './style.css';

function TextComposer({ deal, setMessages, iniciateButton, userId }) {
  const [newMessage, setNewMessage] = useState('');

  const isDisabled = deal?.negotiator_id != userId;

  async function sendMessage(e) {
    e.preventDefault();

    if (deal?.closed) return;

    if (newMessage.trim() !== '') {
      const usuario = localStorage.getItem('usuario');
      const jsonU = JSON.parse(usuario);

      const data = {
        sender_id: jsonU.id,
        receiver_id: deal?.driver_id,
        deal_id: deal?.id,
        message: newMessage,
      };

      setNewMessage('');
      setMessages((prev) => [
        ...prev,
        {
          ...data,
          created_at: new Date(),
        },
      ]);

      try {
        await dealAPI.post('messages', data);
      } catch (ex) {
        // Handle exception
      }
    }
  }

  return (
    !deal?.closed &&
    deal?.negotiator_id && (
      <form onSubmit={sendMessage} className="compose-form">
        <Grid className="compose">
          <div className="compose-input-wrapper">
            <Input
              className="compose-input"
              placeholder="Digite a mensagem..."
              id="composer"
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              disabled={isDisabled || iniciateButton}
              disableUnderline
            />
          </div>
          <Button
            className="compose-send-button"
            disabled={isDisabled || iniciateButton}
            type="submit"
            variant="contained"
          >
            ENVIAR
          </Button>
        </Grid>
      </form>
    )
  );
}

export default TextComposer;
